module.exports = __webpack_public_path__ + "img/logo.235d5c15.svg";